"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMovableColumn = exports.getSelectableColumn = exports.LIMIT_TO_VIRTUALIZE = exports.DEFAULT_CARD_SIZE = void 0;
var tslib_1 = require("tslib");
exports.DEFAULT_CARD_SIZE = 155;
exports.LIMIT_TO_VIRTUALIZE = 20;
function getSelectableColumn(column, isSelectable, isSelected, select) {
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, column), { selectableOptions: {
            isSelectable: isSelectable,
            onSelectAll: function (data) {
                var isEverySelected = data.every(function (item) { return isSelected(item); });
                data.forEach(function (d) {
                    if (!isSelected(d) || isEverySelected) {
                        select(d);
                    }
                });
            },
        }, cards: column.cards.map(function (card) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, card), { onSelect: function (data) { return select(data); }, isSelected: isSelected(card) })); }) });
}
exports.getSelectableColumn = getSelectableColumn;
function getMovableColumn(column, props) {
    var direction = props.direction, isMovable = props.isMovable, isTargetable = props.isTargetable, isTargetButtonDisabled = props.isTargetButtonDisabled, onMove = props.onMove, toggleSelectable = props.toggleSelectable;
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, column), { movableOptions: {
            direction: direction,
            isMovable: isMovable,
            onMove: onMove,
            isTargetable: isTargetable,
            isTargetButtonDisabled: isTargetButtonDisabled,
            toggleSelectable: toggleSelectable,
        } });
}
exports.getMovableColumn = getMovableColumn;
//# sourceMappingURL=utils.js.map